<template>
  <Block class="activity-time" title="活动评委">
    <div class="content">
      <template v-if="isLargeScreen === false">
        <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/judge.png" />
      </template>
      <template v-else>
        <img class="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/judgePC.png" />
      </template>
    </div>
    <Button :style="`margin-top:${isLargeScreen ? '.8rem' : '.56rem'};`" v-if="isStaging3" type="to-rule"
      @click="handleClick"></Button>
  </Block>
</template>

<script setup lang="ts">
import { PageUI } from "./common/api/request";
import Block from "./common/block.vue";
import Button from "./common/button.vue";
import useDevice from "./common/useDevice";

interface Props {
  list: PageUI["reviewers"];
  isStaging3: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  list: () => [],
});

const isLargeScreen = ref(false);
const emit = defineEmits(["toRule"]);
const handleClick = () => {
  emit("toRule");
};
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})
</script>

<style scoped lang="less">
.activity-time {
  margin-bottom: 2.8rem;

  @media screen and(max-width: 1360px) {
    margin-top: 0;
    margin-bottom: 0.76rem;
  }
}

.content {
  --card-wrapper-gap: 0.14rem;
  --card-wrapper-width: 22.36rem;
  --card-wrapper-margin-right: var(--card-wrapper-gap);
  --card-wrapper-margin-bottom: var(--card-wrapper-gap);

  width: calc(var(--card-wrapper-width) + var(--card-wrapper-margin-right));
  margin-top: 0.8rem;
  margin-right: calc(0px - var(--card-wrapper-margin-right));
  margin-bottom: calc(0px - var(--card-wrapper-margin-bottom));

  @media screen and(max-width: 1360px) {
    margin-top: 0.32rem;
    width: 100%;
  }

  .act-img {
    width: 100%;

    @media screen and (max-width: 1360px) {
      width: 100%;
    }
  }
}

.card {
  display: inline-block;
  width: 7.36rem;
  margin: 0 var(--card-wrapper-margin-right) var(--card-wrapper-margin-bottom) 0;

  @media screen and(max-width: 1360px) {
    margin-right: 0.2rem;
  }

  &-name {
    color: #fff;
    font-weight: 600;
    font-size: 0.56rem;
    margin-top: 0.96rem;

    @media screen and(max-width: 1360px) {
      margin-top: 0.2rem;
      font-size: 0.28rem;
      height: 0.4rem;
    }
  }

  &-cover {
    width: 100%;

    @media screen and(max-width: 1360px) {
      width: 1.92rem;
      height: 2.56rem;
    }
  }

  &-role {
    font-weight: 500;
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.4rem;
    margin-top: 0.16rem;

    @media screen and(max-width: 1360px) {
      font-size: 0.2rem;
      margin-top: 0;
    }
  }
}
</style>
